import { createSelector } from '@ngrx/store';
import { OrganizationTypes } from '../../shared/enums/organization.enum';
import { getOrganizationType } from './user.selectors';

const selectHasDeployPermission = createSelector(
  getOrganizationType,
  (organizationType) => organizationType !== OrganizationTypes.Sandbox,
);

export const PermissionsSelectors = {
  selectHasDeployPermission,
};
